<script>
import { mapState } from "vuex";
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import { canAccessContent } from "@/utils/content-access";

export default {
  locales: {
    pt: {
      'Guia do App': 'Guia do App',
    },
    es: {
      'Guia do App': 'Guía de la App',
    }
  },
  components: {
    Layout,
  },
  data() {
    return {
      folders: null,
      showPlayer: false,
      playing: null,
    };
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
  },
  methods: {
    getList() {
      api
        .get('appguide')
        .then((response) => {
          if (response.data.status == 'success') {
            const user = this.account.user;
            const folders = {};
            Object.keys(response.data.folders).forEach((key) => {
              const category = response.data.folders[key];
              if (canAccessContent(category.requires, user)) {
                folders[key] = category;
              }
            });
            this.folders = folders
          }
        })
    },
    playVideo(video) {
      this.playing = video
      this.showPlayer = true
    },
  },
  mounted() {
    this.getList()
  }
};
</script>

<template>
  <Layout>
    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>{{ t('Guia do App') }}</h3>
        <p></p>
      </div>
    </div>

    <div v-if="!folders" class="text-center">
      <b-spinner class="align-middle" variant="default" role="status"></b-spinner>
    </div>
    <div v-else>
      <div v-for="(category, index) in folders" :key="index">
        <div v-if="category.list.length > 0" class="card">
          <div class="card-header rounded bg-default m-1" v-b-toggle="'guide_' + index">
            <h5 class="mb-0 text-white">{{ category.name }}</h5>
          </div>
          <b-collapse :id="'guide_' + index" class="card-body">
            <div class="card-files row">
              <div class="card-file col-md-3 text-center" v-for="(video, vIndex) in category.list" :key="vIndex">
                <div class="video-thumb" @click="playVideo(video)">
                  <img v-if="video.cover" class="file-cover" :src="video.cover" />
                  <div v-else class="file-cover file-cover-placeholder">
                    <i class="mdi mdi-play-circle"></i>
                  </div>
                  <i class="mdi mdi-play-circle video-play-icon"></i>
                </div>
                <h5 class="mb-2 font-size-18">{{ video.title }}</h5>
                <button type="button" class="btn btn-outline-default btn-block" @click="playVideo(video)">Assistir</button>
              </div>
            </div>
          </b-collapse>
        </div>
      </div>
    </div>

    <b-modal v-model="showPlayer" :title="playing ? playing.title : ''" hide-footer size="lg" centered @hidden="playing = null">
      <div v-if="playing">
        <video v-if="showPlayer" :src="playing.url" controls autoplay style="width: 100%; border-radius: 4px;"></video>
        <p v-if="playing.description" class="text-muted mt-3 mb-0">{{ playing.description }}</p>
      </div>
    </b-modal>
  </Layout>
</template>

<style scoped>
.file-cover {
  border-radius: 5px;
  margin-bottom: 10px;
  width: 100%;
  object-fit: cover;
  aspect-ratio: 10 / 5;
}
.file-cover-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.05);
  font-size: 2.5rem;
}
.video-thumb {
  position: relative;
  cursor: pointer;
}
.video-play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, calc(-50% - 5px));
  font-size: 2.5rem;
  color: #fff;
  text-shadow: 0 0 6px rgba(0, 0, 0, 0.6);
  pointer-events: none;
}
@media (max-width: 500px) {
  .card-file {
    margin-bottom: 25px;
  }
}
</style>
